import { render, staticRenderFns } from "./wxwl-cgall.vue?vue&type=template&id=714027bc"
import script from "./wxwl-cgall.vue?vue&type=script&lang=js"
export * from "./wxwl-cgall.vue?vue&type=script&lang=js"
import style0 from "./wxwl-cgall.vue?vue&type=style&index=0&id=714027bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports